import {
  IonButton,
  IonCheckbox,
  IonCol,
  IonGrid,
  IonIcon,
  IonInput,
  IonRow,
  IonText
} from '@ionic/react';
import { LO3_ROLE_NAME, PAGE_TITLES, USER_ROLES } from '../../../utils/constants';
import React, { useEffect, useState } from 'react';

export const ManageUserHeader: React.FunctionComponent<any> = (props: any) => {
  const [showMenu, setShowMenu] = useState(false);
  const [searchValue, setSearchValue] = useState<string>('');
  const [menuItems, setMenuItems] = useState<any>([
      { title: 'Any', id: 1, isChecked: false, value: 'carrierAny' },
      { title: 'Driver', id: 2, isChecked: false, value: 'carrierDriver' },
      { title: 'Dispatcher', id: 3, isChecked: false, value: 'carrierDispatcher' },
      { title: 'Admin', id: 4, isChecked: false, value: 'carrierAdmin' },
      { title: LO3_ROLE_NAME, id: 5, isChecked: false, value: USER_ROLES.carrierLeasedOwnerOpr }
    ]);
  
  const handleCheck = (e: any, role: string) => {
    setMenuItems([...menuItems.map((item: any) => {
      if(item.value === e.detail.value){
        return {...item, isChecked: !item.isChecked}
      }else{
        return {...item};
      }
    })])
  }

  useEffect(() => {
    let options: any = [];
    menuItems.forEach((item: any) => {
      if(item.isChecked){
        options.push(item.value);
      }
    })
    props.filterDataa([...options]);
    if(options.length === 0){
      setShowMenu(false);
    }
  }, [menuItems])

  return (
    <>
      <IonGrid class="manage-user-header" data-testid="manageUserHeader">
        <IonRow>
          <IonCol size="6">
            <h1>{PAGE_TITLES.MANAGE_USERS}</h1>
          </IonCol>
          <IonCol size="6" className="right">
            <IonButton className="add-new-btn"
              data-testid="addNewUser"
              onClick={() => {
                props.addPage();
              }}>
              <IonIcon src="assets/icon/plus.svg" />
              Add User
            </IonButton>
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size="4" class="ion-align-self-center">
            <IonInput class="search-user" data-testid="searchInput" placeholder="Search Name" value={searchValue} onIonChange={(e: any) => {setSearchValue(e.detail.value);
             props.searchData(e.detail.value)}
             }/>
            <IonIcon class="search-icon" src="assets/icon/search-group.svg" />
          </IonCol>
          <IonCol class="suggest-text" size="2.5">
            Search by name or mobile number
          </IonCol>
          <IonCol size="5.5">
            <div className="user-dropdwn">
              <IonButton
                type="button"
                class="dropdown-button user-select-btn ion-no-padding"
                data-testid="userSelectBtn"
                onClick={() => setShowMenu(!showMenu)}>
                <span className="filterBy">Filter</span><span className="filter-bypart">By</span>
                <i className="down"></i>
              </IonButton>
              {showMenu ? (
                <div className="dropdown-list" data-testid="dropdownList">
                  {menuItems.map((item: any) => (
                    <IonRow class="menu-row" key={item.id}>
                      <IonCol size="2" class="menu-icon-col">
                        <IonCheckbox
                          class="checkbox-manage-user"
                          data-testid="manageUserCheckbox"
                          value={item.value}
                          checked={item.isChecked}
                          mode={"md"}
                          onIonChange={e => handleCheck(e, item.title)}
                        />
                      </IonCol>
                      <IonCol size="10" class="menu-title-col">
                        {' '}
                        <IonText>{item.title}</IonText>
                      </IonCol>
                    </IonRow>
                  ))}
                </div>
              ) : null}
            </div>
          </IonCol>
        </IonRow>
      </IonGrid>
    </>
  );
};
